// @flow
import type { Query } from "common/graphql/types"
import gql from "graphql-tag"
import type { Manufacturer } from "data/manufacturer/types"
import { manufacturerFragment } from "./fragments"

export const manufacturerByNameQuery: Query<Manufacturer, { name: string }> = {
  gql: gql`
    query manufacturerByNameQuery($name: String!) {
      manufacturer {
        detailByName(name: $name) {
          ...manufacturerFragment
        }
      }
    }
    ${manufacturerFragment}
  `,
  selector: ["manufacturer", "detailByName"],
}



// WEBPACK FOOTER //
// ./src/data/manufacturer/queries.js